'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react/react.js
 ** module id = 1
 ** module chunks = 0
 **/